import bee from "./Bee";
export default {
    name: "Dashboards",
    get_owners_dashboard(query, success, fail) {
        // success({
        //     num_businesses: "00",
        //     num_promotions: "00",
        //     num_contact_businesses_messages: "00",
        //     num_notifications: "00",
        //     business_views_graph_value: [], //[1, 2, 34, 5, 6, 6, 7, 88, 8, 8, 9],
        //     business_views_graph_labels: [], //[1, 2, 34, 5, 6, 6, 7, 88, 8, 8, 9],
        //     latest_messages: []
        // });

        //last 30 days


        var dashboard_query = {
            _julz:{
                _gets:[{
                    businesses:{
                        _a: " _count ",
                        _w:[
                            ["user_id","e",query.id]
                        ]
                    },
                    promotions:{
                        _a: " _count ",
                        _w:[
                            ["user_id","e",query.id]
                        ]
                    },
                    business_messages:{
                        _a: " _count ",
                        _w:[
                            ["owner_id","e",query.id]
                        ]
                    },
                    notifications:{
                        _a: " _count ",
                        _w:[
                            ["user_id","e",query.id]
                        ]
                    },
                    business_views:{
                        _w:[
                            [
                                [
                                    ["owner_id","e",query.id],
                                    "AND",
                                    ["view_on_timestamp","gte",query.start_time_stamp]
                                ],
                                "AND",
                                ["view_on_timestamp","lte",query.end_time_stamp]
                            ]
                        ]
                    },
                },{
                    business_messages:{
                        _desc: ["id"],
                        _pg: 8,
                        _w:[
                            ["owner_id","e",query.id]
                        ]
                    }
                }]
            }
        };
        bee.get(dashboard_query).then(res=> {
            //console.log("res res:",res);
            if (success) {
                success({
                    num_businesses: res.julz.gets[0].businesses[0].count,
                    num_promotions: res.julz.gets[0].promotions[0].count,
                    num_contact_businesses_messages: res.julz.gets[0].business_messages[0].count,
                    num_notifications: res.julz.gets[0].notifications[0].count,
                    business_views_graph_value: res.julz.gets[0].business_views, //[1, 2, 34, 5, 6, 6, 7, 88, 8, 8, 9],
                    business_views_graph_labels: [], //[1, 2, 34, 5, 6, 6, 7, 88, 8, 8, 9],
                    latest_messages: res.julz.gets[1].business_messages
                });
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    get_admin_dashboard(query, success, fail){
        // success({
        //     num_users: "00",
        //     num_businesses: "00",
        //     num_promotions: "00",
        //     num_adverts: "00",
        //     business_views_graph_value: [], 
        //     business_views_graph_labels: [],
        //     business_searches_graph_value: [],
        //     business_searches_graph_labels: [],
        //     business_searches_graph_value: [],
        //     business_searches_graph_labels: [],
        // });
        
        var dashboard_query = {
            users:{
                _a: " _count "
            },
            businesses:{
                _a: " _count "
            },
            promotions:{
                _a: " _count "
            },
            adverts:{
                _a: " _count "
            },
            business_views:{
                _w:[
                    [
                        ["view_on_timestamp","lte",query.end_time_stamp],
                        "AND",
                        ["view_on_timestamp","gte",query.start_time_stamp]
                    ]
                ]
            },
            search_results:{
                _w:[
                    [
                        ["posted_on_timestamp","lte",query.end_time_stamp],
                        "AND",
                        ["posted_on_timestamp","gte",query.start_time_stamp]
                    ]
                ]
            }
        };
        bee.get(dashboard_query).then(res=> {
            //console.log("res res:",res);
            if (success) {
                success({
                    num_users: res.users[0].count,
                    num_businesses: res.businesses[0].count,
                    num_promotions: res.promotions[0].count,
                    num_adverts: res.adverts[0].count,
                    business_views_graph_value: res.business_views, 
                    business_views_graph_labels: [],
                    business_searches_graph_value: res.search_results,
                    business_searches_graph_labels: [],
                    advert_goal_percentage: 0,
                    registration_goal_percentage: 0
                });
            }
        }).catch(errors => {
            fail(errors);
        });
    }
}